import script from "./TheHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TheHeader.vue?vue&type=script&setup=true&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=df6a0206&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df6a0206"]])

export default __exports__